<template>
    <div class="lofTable">
        <vs-card v-if="$store.state.auth.role === 'admin'">
			<h1>{{$t('exchange.filter')}}</h1>
			<div class="vx-row">
				<div class="vx-col lg:w-2/5 w-full p-3">
					<div class="vx-row">
						<div class="vx-col md:w-1/4 w-full">
							<div class="search">
								<vs-input
									v-model="search"
									:placeholder="$t('numberOrder')"
									class="w-full frsFilterInput"
								/>
							</div>
						</div>
						<div class="vx-col md:w-3/4 w-full">
                            <v-select
                                :clearable="false"
                                v-model="manager"
                                class="single-row-select frsSelect"
                                label="full_name"
                                :options="listManager"
                                :items="listManager"
                                :placeholder="$t('chooseManager')"
                            >      
                                <template slot="selected-option" slot-scope="option">
                                    <span class="frsSelectSpanManager">
                                        <img :src="option.photo" />
                                        {{ option.full_name }}&nbsp; 
                                        <span :class="compColorSpanManager">
                                            <feather-icon icon="ClipboardIcon"></feather-icon>:&nbsp; 
                                            <strong>{{ option.count_active_order }}</strong>
                                        </span>
                                    </span>
                                </template>
                                <template #option="option">
                                    <span class="frsSelectSpanManager">
                                        <img :src="option.photo" />
                                        {{ option.full_name }}&nbsp; 
                                        <span class="frsSelectSpanColorManager">
                                            <feather-icon icon="ClipboardIcon"></feather-icon>:&nbsp; 
                                            <strong>{{ option.count_active_order }}</strong>
                                        </span>
                                    </span>
                                </template>
                            </v-select>
                        </div>				
					</div>
				</div>
				<div class="vx-col lg:w-2/5 w-full p-3">
					<div class="flex">
						<div class="w-1/2 mr-2">
                            <v-select
                                :clearable="false"
                                v-model="author"
                                class="single-row-select frsSelectAuthor"
                                label="full_name"
                                :options="listAuthor"
                                :items="listAuthor"
                                :placeholder="$t('chooseAuthor')"
                            >      
                                <template slot="selected-option" slot-scope="option">
                                    <span class="frsSelectSpanAuthor">
                                        <img :src="option.photo" />
                                        {{ option.full_name }}
                                    </span>
                                </template>
                                <template #option="option">
                                    <span class="frsSelectSpanAuthor">
                                        <img :src="option.photo" />
                                        {{ option.full_name }}
                                    </span>
                                </template>
                            </v-select>
                        </div>				
						<div class="w-1/4 mr-2">
							<vx-input-group>
								<div
									class="vs-component vs-con-input-label vs-input vs-input-primary"
								>
									<div class="vs-con-input"></div>
									<vs-datepicker
										v-model="off"
										format="dd.MM.yyyy"
										:placeholder="$t('exchange.off')"
										name="date_off"
									></vs-datepicker>
								</div>
							</vx-input-group>
						</div>
						<div class="w-1/4">
							<vx-input-group>
								<div
									class="vs-component vs-con-input-label vs-input vs-input-primary"
								>
									<div class="vs-con-input"></div>
									<vs-datepicker
										v-model="to"
										format="dd.MM.yyyy"
										:placeholder="$t('exchange.to')"
										name="date_to"
									></vs-datepicker>
								</div>
							</vx-input-group>
						</div>
					</div>
				</div>
				<div class="vx-col lg:w-1/5 w-full p-3">
					<div class="vx-row">
						<div class="w-2/5 mr-3 ml-3">
							<vs-custom-button
								type="border"
								@click="applyFilter"
								class="logo-block__btn w-full pl-1 pr-1"
							>{{ $t('search') }}</vs-custom-button>
						</div>
						<div class="w-2/5">
							<vs-custom-button
								color="dark"
								type="border"
								@click="clearFilter"
								class="w-full pl-1 pr-1"
							>{{ $t('exchange.reset') }}</vs-custom-button>
						</div>
					</div>
				</div>
			</div>
		</vs-card>
        <LogTableElementTable 
            max-items="10" 
            pagination
            sst
            :total="this.totalPage"
            :currentPage="this.numCurrentPage"
            :data="logs"
            @changePageLog="changePageLog"
            :key="this.offset"
        >

            <template slot="thead">
                <vs-th
                    v-for="fil in field"
                    :sort-key="fil.field.split('.')[0]"
                >
                    {{ $t(fil.title) }}
                </vs-th>
            </template>

            <template slot-scope="{ data }">
                <vs-tr
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                >
                    <template v-for="fil in field">
                        <vs-td v-if="fil.field === 'time'">
                            {{ tr.time }}
                        </vs-td>
                        <vs-td v-if="fil.field === 'orderId'">
                            <template v-if="tr.orderId == 0">
                                - - -
                            </template>
                            <template v-if="tr.orderId != 0">
                                <router-link :to="'/ticket/'+tr.orderId" target='_blank'>
                                    {{ tr.orderId }}
                                </router-link>
                            </template>
                        </vs-td>
                        <vs-td v-if="fil.field === 'user'">
                            <div 
                                v-if="tr.userRole != 'unknowUserRole' && tr.userRole != 'unknowUserName'" 
                                class="frsUserOrderComment"
                            >
                                {{ $t(tr.userRole) }}: <strong>{{ tr.userName }}</strong>
                            </div>
                            <div 
                                v-else 
                                class="frsUserOrderComment"
                            >
                                {{ $t('systemTypeEvent') }}
                            </div>
                        </vs-td>
                        <vs-td v-if="fil.field === 'event'">
                            {{ $t('orderLog.'+tr.event) }}
                            <div v-if="tr.description != '' && tr.description != null" class="mb-1 frsTextOrderComment">
                                {{ $t('orderLog.'+tr.description) }}
                            </div>
                            <div v-if="tr.param != '' && tr.param != null" class="mb-1 frsTextOrderComment">
                                <b>{{ tr.param }}</b>
                            </div>
                        </vs-td>
                    </template>
                </vs-tr>
            </template>
        </LogTableElementTable>
    </div>
</template>

<script>
    import Datepicker from "vuejs-datepicker";
    import databaseManager from "@/mixins/databaseManager";
    import notifier from "@/mixins/notifier";
    import logHeadersList from "@/assets/configs/logHeadersList";
    import LogTableElementTable from "@/views/Logs/LogTableElementTable.vue";
    import vSelect from "vue-select";

    export default {
        name: "LogTable",
        mixins: [databaseManager, notifier],
        props: {
        },
        components: {
            Datepicker,
            LogTableElementTable,
            vSelect,
        },
        data() {
            return {
                listManager: [],
                listAuthor: [],
                date: new Date(),
                logs: [],
                totalPage: 0,
                offset: 0,
                numCurrentPage: 1,
                off: "",
                to: "",
                search: "",
                manager: "",
                author: "",
            };
        },
        computed: {
            minDate() {
                return new Date();
            },

            pathToAuthor() {
                if(this.$store.state.auth.role === "admin") {
                    return 'author';
                } else if(this.$store.state.auth.role === "manager") {
                    return 'authorM';
                }
            },
            pathToClient() {
                if(this.$store.state.auth.role === "admin") {
                    return 'client';
                } else if(this.$store.state.auth.role === "manager") {
                    return 'clientM';
                }
            },
            searchedLogs() {
                let output = {};
                for (let key in this.logs) {
                    output[key] = this.logs[key].filter(item => {
                        if (this.search === "") {
                            return true;
                        }

                        if (item.name !== null && item.name !== undefined) {
                            if (item
                                .name
                                .toLowerCase()
                                .indexOf(this.search.toLowerCase()) !== -1) {

                                return true;
                            }
                        }

                        const clientFullName = item.client.full_name;
                        if (typeof clientFullName === "string" && clientFullName !== "") {
                            if (clientFullName
                                .toLowerCase()
                                .indexOf(this.search.toLowerCase()) !== -1) {

                                return true;
                            }
                        }

                        const clientEmail = item.client.email;
                        if (typeof clientEmail === "string" && clientEmail !== "") {
                            if (clientEmail
                                .toLowerCase()
                                .indexOf(this.search.toLowerCase()) !== -1) {

                                return true;
                            }
                        }

                        if (item.id !== null && item.id !== undefined) {
                            if (item.id == this.search.toLowerCase()) {

                                return true;
                            }
                        }

                        return false;
                    });
                }

                return output;
            },
        },
        methods: {
            async clearFilter(){
                this.to = '';
                this.off = '';
                this.manager = '';
                this.author = '';
                this.search = '';
                this.offset = 0;
                this.numCurrentPage = 1;

                let options = {
                    limit: 10,
                    offset: 0,
                };

                try {
                    await this.filter(options);
                } catch(e) {
                    this.notifyError(e.message);
                }
            },
            async applyFilter() {
                let options = {
                    off: this.off,
                    to: this.to,
                    manager: this.manager.id,
                    author: this.author.id,
                    search: this.search,
                    limit: 10,
                    offset: 0,
                };

                this.offset = 0;
                this.numCurrentPage = 1;

                try {
                    await this.filter(options);
                } catch(e) {
                    this.notifyError(e.message);
                }
            },
            async getListManager() {
                this.listManager = await this.dbGetListMangers();
            },
            async getListAuthor() {
                this.listAuthor = await this.dbGetListAuthors();
            },
            changePageLog(val) {
                let newOffset = (val-1)*10;
                let options={
                    off: this.off,
                    to: this.to,
                    manager: this.manager.id,
                    author: this.author.id,
                    search: this.search,
                    limit: 10,
                    offset: newOffset,
                };

                this.filter(options);
                this.offset = newOffset;
                this.numCurrentPage = val;
            },
            async filter(options = null) {
				try {
					let requestOptions = options || {
						limit: 10,
						offset: 0,
					};

					let bigData = await this.dbGetFilteredLogs(requestOptions);
                    this.totalPage = bigData.count;

                    let newListLogs = [];
                    let iNumLog = requestOptions.offset;
                    bigData.data.forEach(function(elem) {
                        newListLogs[iNumLog] = elem;
                        iNumLog++;
                    });
					this.logs  = newListLogs;

				} catch (e) {
					this.notifyError(e.message);
				}
			},
        },
        async created() {
            const role = this.$store.state.auth.role;
            const headers = logHeadersList.getHeaders(role);
            this.field = headers.field;

            // this.off = '2024-03-10';

            if(role === 'admin') await this.getListManager();
            if(role === 'admin') await this.getListAuthor();
        },
        async mounted() {
            try {
                await this.filter();
            } catch(e) {
                this.notifyError(e.message);
            }
        },
    };
</script>

<style lang="scss" scoped>
    @import "./src/assets/scss/vuexy/functions";
    @import "./src/assets/scss/vuexy/variables";

    .frsSelect {
        min-width: 300px;
        font-size: small;
        line-height: 28px;
    }

    .frsSelectAuthor {
        min-width: 100px;
        font-size: small;
        line-height: 28px;
    }

    .frsSelectSpanAuthor {
        display: flex;
        line-height: 28px;
        font-size: small;
        color: black;
    
        img {
            width: 28px;
            margin-right: 10px;
        }	

    }
    .frsSelectSpanManager {
        display: flex;
        line-height: 28px;
        font-size: small;
        color: black;
    
        img {
            width: 28px;
            margin-right: 10px;
        }	

    }
    .frsSelectSpanColorManager {
        display: flex;
        line-height: 28px;
        font-size: small;
    }
    .align-center {
	    align-items: center;
    }
    .mini-img {
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        border-radius: 100%;
    }
</style>